import { Form } from 'antd';
import { Box, Button, Col, Colors, IcArrowRight, IcCode, Text } from 'basic-ui-lib';
import InputCentered from 'basic-ui-lib/components/Input/InputCentered';
import { IDevice } from 'modules/dashboard/interfaces/api';
import dashboardApis from 'modules/dashboard/services/apis';
import { useNavigate } from 'react-router-dom';
import { getMessageError } from 'services/response';
import toast from 'utils/toast';
import { setPageLoading } from 'widgets/PageLoading';

interface EnterCodeFormProps {
  storeId: string;
  onContinue: () => void;
}

interface EnterCodeFormValues {
  screenCode: string;
}

const EnterCodeForm = ({ storeId, onContinue }: EnterCodeFormProps) => {
  const navigate = useNavigate();
  const [form] = Form.useForm<EnterCodeFormValues>();

  const handleContinue = async (values: EnterCodeFormValues) => {
    try {
      setPageLoading(true);
      const res = await dashboardApis.checkDeviceByCode(values.screenCode.trim());
      if (!res?.data?.data) {
        toast.error('Device not found. Please check the pairing code.');
        return;
      }

      const device = res.data.data as IDevice;

      onContinue();
      navigate('/screen/create', {
        state: {
          storeId,
          screenName: device.deviceName,
          deviceInfo: device,
        },
      });
    } catch (error) {
      toast.error(getMessageError(error, 'Failed to verify pairing code.'));
    } finally {
      setPageLoading(false);
    }
  };

  return (
    <Form form={form} layout='vertical' onFinish={handleContinue}>
      <div className='enter-code'>
        <Col>
          <Box className='box-icon' backgroundColor={Colors.secondary[1]}>
            <IcCode width={40} height={40} fill={Colors.secondary[5]} />
          </Box>
          <Box>
            <Text title_h9 semibold>
              App
            </Text>
            <Text body_1 regular color='neutral.text.3'>
              Pair your device instantly using the 6 digit code displayed on your screen.
            </Text>
          </Box>
        </Col>
        <Col marginTop={16} marginBottom={16}>
          <Form.Item
            name='screenCode'
            rules={[
              { required: true, message: 'Please enter the screen code' },
              // { pattern: /^\d{6}$/, message: 'Screen code must be a 6 digit' },
            ]}
          >
            <InputCentered placeholder='Screen Code' maxLength={6}/>
          </Form.Item>
          {/* <Form.Item name='screenName' rules={[{ required: true, message: 'Please enter the screen name' }]}>
            <InputCentered placeholder='Screen Name' />
          </Form.Item> */}
        </Col>
        <Button suffix={<IcArrowRight width={24} height={24} fill={Colors.neutral.bg[1]} />} lg type_second type='submit'>
          Connect Screen
        </Button>
      </div>
    </Form>
  );
};

export default EnterCodeForm;
